import jsonPointer from 'json-pointer';
import set from 'set-value';
import toDataPath from './toDataPath';

export default function createCustomSchema(fields) {
  if (fields == null) {
    return null;
  }

  const newSchema = {
    type: 'object',
    propertyOrder: fields.map((field$ref) => toDataPath(field$ref)),
  };

  for (const field$ref of fields) {
    const cleanField$ref = field$ref.replace(/^#?(.*)/, '$1');
    const segments = jsonPointer.parse(cleanField$ref);

    set(newSchema, segments.join('.'), { $ref: cleanField$ref });
  }

  return newSchema;
}
